// The step card is 288px. Placement uses the same width so the card sits beside the
// anchor instead of covering it.
export const WIZARD_WIDGET_W = 288;

type AnchorRect = {
  left: number;
  top: number;
  width: number;
  height: number;
  right: number;
  bottom: number;
};

// Side placements center on the anchor's vertical middle. A boundary or ring rect can be tall.
function clampTop(t: number): number {
  return Math.max(8, Math.min(window.innerHeight - 180, t));
}

// Beside the anchor: left of it when it sits in the right half of the screen, else right.
// No anchor yet → bottom-center, so the text stays reachable while a pane still builds.
// A centered step (the finale) sits mid-screen instead.
export function wizardWidgetPos(
  rect: AnchorRect | null,
  side: "left" | "right" | "over" | undefined,
  center: boolean | undefined,
): { left: number; top: number } {
  const vw = window.innerWidth;
  const midTop = rect ? clampTop(rect.top + rect.height / 2 - 60) : 0;
  if (!rect) {
    return center
      ? {
          left: vw / 2 - WIZARD_WIDGET_W / 2,
          top: window.innerHeight / 2 - 90,
        }
      : { left: vw / 2 - WIZARD_WIDGET_W / 2, top: window.innerHeight - 220 };
  }
  if (side === "left") {
    return {
      left: Math.max(8, rect.left - WIZARD_WIDGET_W - 12),
      top: midTop,
    };
  }
  if (side === "right") {
    return {
      left: Math.min(vw - WIZARD_WIDGET_W - 8, rect.right + 12),
      top: midTop,
    };
  }
  if (side === "over") {
    return {
      left: Math.max(
        8,
        Math.min(
          vw - WIZARD_WIDGET_W - 8,
          rect.left + rect.width / 2 - WIZARD_WIDGET_W / 2,
        ),
      ),
      top: midTop,
    };
  }
  return {
    left:
      rect.left > vw / 2
        ? Math.max(8, rect.left - WIZARD_WIDGET_W - 12)
        : Math.min(vw - WIZARD_WIDGET_W - 8, rect.right + 12),
    top: clampTop(rect.top),
  };
}
